module.exports = __webpack_public_path__ + "img/come-vict-04.7136c929.jpg";